import React, { useLayoutEffect, useState } from "react";
import { getBannerRendition } from "../../utils/responsiveBanner";

const BannerImage = ({ src, fallback, className, enabled = true }) => {
  const [failure, setFailure] = useState(0);
  const rendition = getBannerRendition(src);
  const [activated, setActivated] = useState(enabled);
  useLayoutEffect(() => {
    if (enabled) setActivated(true);
  }, [enabled]);
  const ready = enabled || activated;
  return (
    <img
      className={className}
      style={{ objectFit: "cover", objectPosition: "center" }}
      alt=""
      src={ready ? (failure === 0 ? rendition : failure === 1 ? src : fallback) : undefined}
      onError={() => {
        // A provider may reject this rendition while its original remains available.
        if (failure === 0 && rendition !== src) setFailure(1);
        else if (failure < 2) setFailure(2);
      }}
    />
  );
};

const ResponsiveBanner = (props) => <BannerImage key={props.src} {...props} />;
export default ResponsiveBanner;
